// extracted by mini-css-extract-plugin
module.exports = {"Feedback":"FormFeedback_Feedback__Cjpix","danger":"FormFeedback_danger__10Blf","warning":"FormFeedback_warning__3yTm6"};